
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import FutureProfessionsCard from '~/components/Cards/FutureProfessionsCards/FutureProfessionsCard.vue'
import { FutureProfItemModel } from '~/model'

export default defineComponent({
  name: 'FutureProfessionsGrid',
  components: {
    FutureProfessionsCard
  },
  props: {
    futureProfessions: {
      type: Array as PropType<Array<FutureProfItemModel>>,
      default: () => []
    }
  }
})
